import React from 'react';
import VariableCell from './VariableCell';
import { getValueAtPath, parseTokenPath } from './documentStateHelpers';
import { resolveVariableFieldBinding } from './resolveVariableField';
import { getVariableSegmentsFromMeta } from './variableTokenHelpers';

/**
 * Renders a cell that mixes literal text with one or more {{variable}} inline editors.
 */
const MixedVariableCell = ({
  variableMeta,
  cellText,
  appChoices,
  docSource,
  documentState,
  pickedInventory,
  textAlign = 'left',
  onDocumentPathChange,
  onInventoryPathChange
}) => {
  const segments = getVariableSegmentsFromMeta(variableMeta, cellText);

  return (
    <div className="dochub-sheet-renderer__mixed-content" style={{ textAlign }}>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return (
            <span key={`text-${index}`} className="dochub-sheet-renderer__mixed-text">
              {segment.value}
            </span>
          );
        }

        const path = parseTokenPath(segment.fullToken);
        if (!path.length) return null;

        const binding = resolveVariableFieldBinding({
          path,
          appChoices,
          docSource,
          pickedInventory
        });
        const rawValue =
          binding.owner === 'inventory'
            ? getValueAtPath(pickedInventory, binding.statePath)
            : getValueAtPath(documentState, binding.statePath);
        const inventoryBound = binding.owner === 'inventory';

        return (
          <VariableCell
            key={`var-${segment.fullToken}-${index}`}
            inline
            binding={binding}
            value={rawValue}
            textAlign={textAlign}
            title={segment.fullToken}
            disabled={inventoryBound && !pickedInventory}
            appChoices={appChoices}
            buyerEmail={documentState?.buyerEmail}
            onChange={next => {
              if (inventoryBound) {
                if (onInventoryPathChange) {
                  onInventoryPathChange(binding.statePath, next);
                }
              } else if (onDocumentPathChange) {
                onDocumentPathChange(binding.statePath, next);
              }
            }}
          />
        );
      })}
    </div>
  );
};

export default MixedVariableCell;
